module.exports = __webpack_public_path__ + "static/media/laurea-logo.fi.a6f0fc42.png";